import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="prices"
export default class Prices extends Controller {
  static targets = ["tab", "panel"]
  static classes = ["activeTab", "inactiveTab"]

  connect() {
    super.connect()
    // Show first tab by default
    if (this.tabTargets.length > 0) {
      this.showTab(this.tabTargets[0])
    }
  }

  showTab(selectedTab) {
    // Update tab styles
    this.tabTargets.forEach((tab, index) => {
      if (tab === selectedTab) {
        tab.querySelector('a').classList.remove(...(this.inactiveTabClass || '').split(' '))
        tab.querySelector('a').classList.add(...(this.activeTabClass || '').split(' '))
        this.panelTargets[index].classList.remove('hidden')
      } else {
        tab.querySelector('a').classList.add(...(this.inactiveTabClass || '').split(' '))
        tab.querySelector('a').classList.remove(...(this.activeTabClass || '').split(' '))
        this.panelTargets[index].classList.add('hidden')
      }
    })
  }

  change(event) {
    event.preventDefault()
    this.showTab(event.currentTarget)
  }

  // Keyboard navigation
  previousTab(event) {
    event.preventDefault()
    let index = this.tabTargets.indexOf(event.currentTarget)
    index = index > 0 ? index - 1 : this.tabTargets.length - 1
    this.showTab(this.tabTargets[index])
  }

  nextTab(event) {
    event.preventDefault()
    let index = this.tabTargets.indexOf(event.currentTarget)
    index = index < this.tabTargets.length - 1 ? index + 1 : 0
    this.showTab(this.tabTargets[index])
  }

  firstTab(event) {
    event.preventDefault()
    this.showTab(this.tabTargets[0])
  }

  lastTab(event) {
    event.preventDefault()
    this.showTab(this.tabTargets[this.tabTargets.length - 1])
  }
}
